import React from 'react';

const StatsDisplay = ({ transcriptionsCount, audioStats }) => {
  return (
    <div>
      <h3 className="text-sm font-semibold text-zinc-300 mb-3">Statistics</h3>
      <div className="glass-panel p-3 rounded-lg space-y-2 text-xs">
        <div className="flex justify-between">
          <span className="text-zinc-400">Messages:</span>
          <span className="text-white font-medium">{transcriptionsCount}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-zinc-400">Data Sent:</span>
          <span className="text-white font-medium">
            {(audioStats.totalBytesSent / 1024 / 1024).toFixed(2)} MB
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-zinc-400">Audio Chunks:</span>
          <span className="text-white font-medium">{audioStats.totalChunksSent}</span>
        </div>
      </div>
    </div>
  );
};

export default StatsDisplay;
